import React, { FC } from 'react';
import { withHeader } from '../../HOC/withHeader';
import { RecognitionHubPage } from '../../modules/recognition/RecognitionHubPage';

const Module: FC = () => <RecognitionHubPage />;

export const RecognizePageContainer: FC = withHeader(Module);
